import React, { useRef, useState } from 'react';
import Header from './components/Header';
import Home from './components/Home';
import Experiences from './components/Experiences';
import Projects from './components/Projects';
import './App.css';

function App() {
  const containerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch(currentPage) {
      case 'experiences':
        return <Experiences containerRef={containerRef} />;
      case 'projects':
        return <Projects containerRef={containerRef} />;
      default:
        return <Home containerRef={containerRef} />;
    }
  };

  return (
    <div className="App" ref={containerRef} style={{position: 'relative', overflow: 'visible', width: '100%', height: '100%'}}>
      <Header containerRef={containerRef} currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {renderPage()}
    </div>
  );
}

export default App;